/**
 * Counts the total number of selected multi-select filters
 * @param multiSelects - Object containing multi-select filter arrays
 * @returns Total count of selected filters
 */
export const getMultiSelectCount = (multiSelects: Record<string, string[]>): number =>
  Object.values(multiSelects).reduce((count, { length }) => count + length, 0);
